// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetParamData, GetParamResponses, GetSiteData, GetSiteLotteriesByLotteryIdWinnersData, GetSiteLotteriesByLotteryIdWinnersResponses, GetSiteResponses, GetSiteTestSideEventProgressByProgressByUidData, GetSiteTestSideEventProgressByProgressByUidResponses, GetUserLotteriesWinsData, GetUserLotteriesWinsResponses, GetUserMeData, GetUserMeResponses, GetUserMissionLogsData, GetUserMissionLogsResponses, GetUserRewardsData, GetUserRewardsResponses, GetUserStateData, GetUserStateResponses, PostUserClaimAccumulateSpinData, PostUserClaimAccumulateSpinResponses, PostUserClaimItemByItemIdData, PostUserClaimItemByItemIdResponses, PostUserSpinData, PostUserSpinResponses, PostUserUpdateMissionData, PostUserUpdateMissionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Common params
 */
export const getParam = <ThrowOnError extends boolean = false>(options: Options<GetParamData, ThrowOnError>) => (options.client ?? client).get<GetParamResponses, unknown, ThrowOnError>({ url: '/param', ...options });

export const getSite = <ThrowOnError extends boolean = false>(options?: Options<GetSiteData, ThrowOnError>) => (options?.client ?? client).get<GetSiteResponses, unknown, ThrowOnError>({ url: '/site', ...options });

/**
 * Get list of daily lottery winners of a lottery
 */
export const getSiteLotteriesByLotteryIdWinners = <ThrowOnError extends boolean = false>(options: Options<GetSiteLotteriesByLotteryIdWinnersData, ThrowOnError>) => (options.client ?? client).get<GetSiteLotteriesByLotteryIdWinnersResponses, unknown, ThrowOnError>({ url: '/site/lotteries/{lotteryId}/winners', ...options });

export const getSiteTestSideEventProgressByProgressByUid = <ThrowOnError extends boolean = false>(options: Options<GetSiteTestSideEventProgressByProgressByUidData, ThrowOnError>) => (options.client ?? client).get<GetSiteTestSideEventProgressByProgressByUidResponses, unknown, ThrowOnError>({ url: '/site/test/side-event/progress/{progress}/{uid}', ...options });

/**
 * Get user session
 */
export const getUserMe = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeData, ThrowOnError>) => (options?.client ?? client).get<GetUserMeResponses, unknown, ThrowOnError>({ url: '/user/me', ...options });

/**
 * Get user state
 */
export const getUserState = <ThrowOnError extends boolean = false>(options?: Options<GetUserStateData, ThrowOnError>) => (options?.client ?? client).get<GetUserStateResponses, unknown, ThrowOnError>({ url: '/user/state', ...options });

/**
 * Update user mission progress
 */
export const postUserUpdateMission = <ThrowOnError extends boolean = false>(options?: Options<PostUserUpdateMissionData, ThrowOnError>) => (options?.client ?? client).post<PostUserUpdateMissionResponses, unknown, ThrowOnError>({ url: '/user/update-mission', ...options });

/**
 * Spin and return new user state and receive items. Accumulate items will be automatically claimed
 */
export const postUserSpin = <ThrowOnError extends boolean = false>(options: Options<PostUserSpinData, ThrowOnError>) => (options.client ?? client).post<PostUserSpinResponses, unknown, ThrowOnError>({
    url: '/user/spin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim random accumulate rewards.
 */
export const postUserClaimAccumulateSpin = <ThrowOnError extends boolean = false>(options?: Options<PostUserClaimAccumulateSpinData, ThrowOnError>) => (options?.client ?? client).post<PostUserClaimAccumulateSpinResponses, unknown, ThrowOnError>({ url: '/user/claim-accumulate-spin', ...options });

/**
 * Claim item by itemId
 */
export const postUserClaimItemByItemId = <ThrowOnError extends boolean = false>(options: Options<PostUserClaimItemByItemIdData, ThrowOnError>) => (options.client ?? client).post<PostUserClaimItemByItemIdResponses, unknown, ThrowOnError>({ url: '/user/claim-item/{itemId}', ...options });

/**
 * Get list of user lottery wins
 */
export const getUserLotteriesWins = <ThrowOnError extends boolean = false>(options?: Options<GetUserLotteriesWinsData, ThrowOnError>) => (options?.client ?? client).get<GetUserLotteriesWinsResponses, unknown, ThrowOnError>({ url: '/user/lotteries/wins', ...options });

export const getUserMissionLogs = <ThrowOnError extends boolean = false>(options?: Options<GetUserMissionLogsData, ThrowOnError>) => (options?.client ?? client).get<GetUserMissionLogsResponses, unknown, ThrowOnError>({ url: '/user/mission-logs', ...options });

/**
 * List user rewards history. Filter by "source" if specified.
 */
export const getUserRewards = <ThrowOnError extends boolean = false>(options?: Options<GetUserRewardsData, ThrowOnError>) => (options?.client ?? client).get<GetUserRewardsResponses, unknown, ThrowOnError>({ url: '/user/rewards', ...options });
